module.exports = __webpack_public_path__ + "img/tut4.7b385444.gif";